import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetEcrFileInformationsResData extends ServiceResponseData {
    public version: string;
    public lastUpdate: Date;

    constructor(response: AxiosResponse) {
        super(response);
        this.version = null;
        this.lastUpdate = null;
        if (response.data && response.data.Payload) {
            this.version = response.data.Payload.Version;
            this.lastUpdate = response.data.Payload.LastUpdate;
        }
    }
}
